import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'searchBlogs'
})
export class SearchBlogsPipe implements PipeTransform {

  transform(value: any, ...args: any[]): any {
    if (!args) {
      return value;
    }
    return value.filter((val: any) => {
      let rVal = (val.title.toLocaleLowerCase().includes(args))
        || (val.sub_title.toLocaleLowerCase().includes(args))
        || (val.short_description.toLocaleLowerCase().includes(args));
      return rVal;
    })
  }
}
